import React from "react"
import Footer from "../components/Footer"
import Header from "../components/Header"
import SecondaryResourcesCategoryView from "./SecondaryResourcesCategoryView"
import Prep1TB from "../images/prep-1.jpg"
import ZipLogo from "../images/zip.svg"

class Prep1Resources extends React.Component {
  state = {
    view: {
      title: "Preparatory 1 Resources",
      parentURL: "/resources",
      parentName: "resources",
      categories: [
        {
          name: "Teacher's Book",
          file: Prep1TB,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-nov-2022/G7-Preparatory-1-TB_WM_2022.pdf",
        },
        {
          name: "Audio",
          fileType: ZipLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/audio-april-2022/",
          files: [
            { name: "Preparatory 1 Audio", file: "Preparatory-1-audio.zip" },
          ],
        },
      ],
    },
  }

  render() {
    return (
      <div>
        <Header />

        <SecondaryResourcesCategoryView data={this.state.view} />

        <Footer />
      </div>
    )
  }
}

export default Prep1Resources



// WEBPACK FOOTER //
// ./src/components/ResourcesPrep1.js